var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'paternity-card-form__container': true}},[_vm._t("form-area")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }